import axios from 'axios';
import APIS from '../../apis/careerCard';
import qs from 'qs';
import {
  callbackHandler,
} from '../callbackHandler';

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    //获取生涯卡答题页
    lifeCardCardList(context, params) {
      return axios.get(APIS.lifeCardCardList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.lifeCardCardList, res);
        return res.data;
      })
    },
    //提交生涯卡答案
    lifeCardCommitAnswer(context, {env, params}={}) {
      return axios.post(APIS.lifeCardCommitAnswer, qs.stringify(params, { indices: false })).then(function (res) {
        callbackHandler(APIS.lifeCardCommitAnswer, res);
        return res.data;
      })
    },
    //获取生涯卡报告
    lifeCardViewReport(context, params) {
      return axios.get(APIS.lifeCardViewReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.lifeCardViewReport, res);
        return res.data;
      })
    },
    //获取生涯卡报告
    getTeacher(context, params) {
      return axios.get(APIS.getTeacher, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getTeacher, res);
        return res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/careercard.js